<template>
	<slot :open="isOpen" :toggleOpen="toggle"></slot>
</template>

<script setup>
import { ref } from 'vue'
const isOpen = ref(false);

const toggle = () => {
	isOpen.value = !isOpen.value;
};
</script>
